<!-- src/views/Home.vue -->
<template>
	<h1>Home Page</h1>
	<p>Welcome to the Omnicasa upload files page.</p>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "Home"
});
</script>
